/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
import requester from '../../utils/requester';
import config from '../../config';
import offlineDB from '../index';


const syncOfflineEvents = () => new Promise(async (resolve, reject) => {

    // Algorithm of submitting offline events (logs):
    // check offline files, upload them first => update in event
    // send event to the server => delete event from offlineDB

    try {
        const userInfo = await requester.authNeed().contentType('application/json').get(config.serverURL + '/user');
        if (userInfo?.data?.results?.id) {
            const userId = userInfo.data.results.id;

            const offlineEventsList = await offlineDB.syncEvents.getEventsList();
            if (offlineEventsList?.success) {
                if (offlineEventsList?.data?.length) {
                    // just selected items related to currect user to sync
                    const filteredListByUserId = offlineEventsList.data.filter(item => item?.userId?.toString() === userId.toString());
                    for (const singleEvent of filteredListByUserId) {

                        // upload picture and save returned url
                        let uploadedPictureURL = null;
                        const eventPictureOfflineDBID = singleEvent?.extraProperties?.picture?.offlineDBID || null;
                        if (eventPictureOfflineDBID) {
                            try {
                                const pictureOnOfflineDB = await offlineDB.files.getFile(eventPictureOfflineDBID);
                                if (pictureOnOfflineDB) {
                                    const blob = pictureOnOfflineDB.file;
                                    const formData = new FormData();
                                    formData.append('fileupload', blob, 'fileupload.jpg');
                                    const uploadResult = await requester.contentType(false).authNeed().post(config.serverURL + '/upload', formData, true);
                                    if (uploadResult?.data?.results?.[0]?.uri) {
                                        const uploadedURL = uploadResult.data.results[0].uri;
                                        uploadedPictureURL = uploadedURL;
                                        try {
                                            offlineDB.files.deleteFile(eventPictureOfflineDBID);
                                        }
                                        catch { }
                                    }
                                    else {
                                        // failed to upload file
                                        try {
                                            offlineDB.files.deleteFile(eventPictureOfflineDBID);
                                        }
                                        catch { }
                                    }
                                }
                            }
                            catch { }
                        }


                        // upload attachments and save returned urls array
                        let uploadedAttachmentsList = null;
                        const eventAttachmentsList = singleEvent?.extraProperties?.attachments || null;
                        if (eventAttachmentsList?.length) {
                            const attachmentsList = [];
                            for (const singleAttachment of eventAttachmentsList) {
                                if (singleAttachment && singleAttachment.offlineDBID) {
                                    try {
                                        const fileOnOfflineDB = await offlineDB.files.getFile(singleAttachment.offlineDBID);

                                        if (fileOnOfflineDB && fileOnOfflineDB.success) {
                                            const file = fileOnOfflineDB.file;
                                            const formData = new FormData();
                                            formData.append('fileupload', file, file.name);
                                            const uploadResult = await requester.contentType(false).authNeed().post(config.serverURL + '/upload', formData, true);

                                            if (uploadResult?.data?.results?.[0]?.uri) {
                                                attachmentsList.push(uploadResult.data.results[0].uri);
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch {
                                                }
                                            }
                                            else {
                                                // failed to upload file
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch {
                                                }
                                            }
                                        }
                                    }
                                    catch { }
                                }
                            }
                            uploadedAttachmentsList = attachmentsList;
                        }


                        const eventSaveObject = singleEvent;
                        if (eventSaveObject?.extraProperties) {
                            eventSaveObject.extraProperties?.picture && (eventSaveObject.extraProperties.picture = uploadedPictureURL || null);
                            eventSaveObject.extraProperties?.attachments && (eventSaveObject.extraProperties.attachments = uploadedAttachmentsList || []);
                        }
                        const eOfflineId = singleEvent.offlineId;

                        delete eventSaveObject.offlineId;

                        const newEvent = await requester.contentType('application/json').authNeed().post(config.serverURL + '/events', eventSaveObject);

                        if (newEvent?.data?.results?.affectedRows === 1) {
                            // delete event from offline sync store after submit
                            try {
                                offlineDB.syncEvents.deleteEvent(eOfflineId);
                            }
                            catch { reject(); }
                        }
                    }
                    resolve(); // resolve after loop
                }
                else { resolve(); } // offline events list is empty
            }
            else { reject('error - syncOfflineEvent1'); }
        }
        else { reject('error - syncOfflineEvent1 - user not found'); }
    }
    catch (error) { console.log(error); reject('error - syncOfflineEvents2'); }
});

export default syncOfflineEvents;
